module.exports = __webpack_public_path__ + "static/media/productos_botanas_garbanzo_enchilado.14de2476.jpg";